// LES CONTRÔLEURS DU SITE PUBLIC.
//
// CE FICHIER EXISTE POUR CE QU'IL NE CONTIENT PAS. Le paquet était unique : un visiteur du site
// public téléchargeait Quill et Sortable — l'éditeur de texte riche et le glisser-déposer du
// back-office — soit environ 330 Ko qu'il n'emploie jamais. Mesuré avant découpe : 1 371 229 octets
// bruts, 297 939 une fois compressés.
//
// LEAFLET RESTE ICI, et c'est le seul poids lourd qui le mérite : la carte d'une date d'agenda est
// une page publique (voir agenda/_date.html.erb).
//
// AJOUTER UN CONTRÔLEUR AU SITE PUBLIC, c'est l'ajouter ICI. Oublié, il ne lèvera aucune erreur :
// Stimulus ignore en silence un `data-controller` qu'il ne connaît pas, et la fonctionnalité
// manquera sans que rien ne le signale. C'est le prix de la découpe, et la raison de ce paragraphe.

import "./shared"
import { application } from "./application"

import CoverParallaxController from "./cover_parallax_controller"
application.register("cover-parallax", CoverParallaxController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MapController from "./map_controller"
application.register("map", MapController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OutlineController from "./outline_controller"
application.register("outline", OutlineController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import ThemeShowcaseController from "./theme_showcase_controller"
application.register("theme-showcase", ThemeShowcaseController)
